import {
    ExperimentGroupDTO,
    ExperimentObjective,
} from "@/services/experimentGroups/experimentGroupsAPI";
import { SavedObject } from "@/services/commonModels";

export type ExperimentMetadata = {
    // a metadata record will be associated to either an experimentGroup or
    // an experiment, but not both
    experimentGroupId: string | null;
    experimentId: number | null;

    // these fields will all come from registries:
    operator: string[] | null;
    investigator: string | null;
    studyDirector: string | null;
    invaioProject: string | null;

    // location-related fields
    latitudeNorthwestCorner: number | null;
    longitudeNorthwestCorner: number | null;
    latitudeSoutheastCorner: number | null;
    longitudeSoutheastCorner: number | null;
    ffDistanceFromTrunk: number | null;
    site: string | null;

    // GLP/GEP
    conductedUnderGEP: boolean | null;
    conductedUnderGLP: boolean | null;
    samplesProcessedInGLPLab: boolean | null;

    // should this be on the experiments table instead?
    // pocAndOmitFromAnalysis: boolean; // can this be retired in favor of experiment status?
};

export type ExperimentMetadataDTO = Partial<ExperimentMetadata>;

export type SavedExperimentMetadata = ExperimentMetadata & SavedObject<string>;

/**
 * find the subset of the experiment name that is the trial code; it will always be 20 chars with hyphens
 * like "NA-24-ORG-OP-001-001", not necessarily the first 20 chars of the experiment name
 */
export function getTrialCodeFromExperimentName(experimentName: string) {
    const match = experimentName.match(/([A-Z]{2}-\d{2}-[A-Z]{3}-[A-Z]{2}-\d{3}-\d{3})/);
    return match ? match[0] : null;
}

export function buildExperimentObjectivesOptions(
    experimentGroups: ExperimentGroupDTO[]
): ExperimentObjective[] {
    const objectives = experimentGroups
        .filter((group) => group.objective !== null)
        .map((group) => group.objective!)
        .filter((value, index, self) => self.indexOf(value) === index); // unique values
    objectives.sort();
    objectives.push(ExperimentObjective.NONE);
    return objectives;
}
